var map = {
	"./changelog/changelog.module": [
		"./src/app/changelog/changelog.module.ts",
		"changelog.module"
	],
	"./pages/content-layout-page/content-pages.module": [
		"./src/app/pages/content-layout-page/content-pages.module.ts",
		"content-pages.module"
	],
	"./pages/full-layout-page/full-pages.module": [
		"./src/app/pages/full-layout-page/full-pages.module.ts",
		"full-pages.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main